import React, {useContext} from "react";
import {Col, Form} from "react-bootstrap";
import {
    FOOTER_BASE_CP_DISCLM_108, FOOTER_BASE_FIN_STMT_108,
    FOOTER_BASE_URL
} from "../service/UrlConstant";
import {UtilsContext} from "../context/utils";

const Component0108 = (props) =>{
    const {handleStreamPdf} = useContext(UtilsContext);
    const financialStatementsUrl = `${FOOTER_BASE_URL}/${FOOTER_BASE_FIN_STMT_108}`;
    const clientPortalDisclaimersUrl = `${FOOTER_BASE_URL}/${FOOTER_BASE_CP_DISCLM_108}`;

    return(
        <Col className={`${props.isLogin?'text-left px-2':'text-center'} login-app-footer`}>
            <br/>
            {!props.isLogin &&
                (
                    <>
                        Client Portal Users: {props.isLogin && <br/>} Please
                        <a className="td-cta td-link" href={clientPortalDisclaimersUrl} onClick={(event) => handleStreamPdf(clientPortalDisclaimersUrl, FOOTER_BASE_CP_DISCLM_108, event)} target="_blank"> click here to view important legal, disclaimer and disclosure information</a> for our client portal.<br/>
                        <a className="td-cta td-link" href={financialStatementsUrl} onClick={(event) => handleStreamPdf(financialStatementsUrl, FOOTER_BASE_CP_DISCLM_108, event)} target="_blank">Financial Statements</a><br/>
                    </>
                )
            }
        </Col>
    )

}
export default Component0108